import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AbstractValueAccessorComponent, ValueAccessorUtil } from '@railmybox/shared/util';

type FileExtension = `.${string}`;
type MimeType = `${string}/${string}`;
type MediaTypeWildcard = 'image/*' | 'audio/*' | 'video/*';
export type FileType = FileExtension | MimeType | MediaTypeWildcard;

@Component({
  selector: 'eg-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  providers: [...ValueAccessorUtil.getValueAccessorProvider(UploadComponent)],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class UploadComponent extends AbstractValueAccessorComponent<any> implements OnInit {
  readonly TRANSLOCO_PREFIX = 'upload';
  @Input() file: any;
  @Input() deletable = true;
  @Input() documentType: string;
  @Input() isDocumentScanning: boolean;
  private _acceptedFileTypes: FileType[] = ['.pdf'];
  @Output() deleteClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() downloadClicked: EventEmitter<string> = new EventEmitter<string>();
  selectedFileName: string;

  protected override setStatus(status: string): void {
    this._status = status;
  }

  @Input()
  set acceptedFileTypes(types: FileType[]) {
    this._acceptedFileTypes = types;
  }

  get acceptedFileTypes(): string {
    return this._acceptedFileTypes.join(',');
  }

  ngOnInit(): void {
    if (this.file) {
      this.selectedFileName = this.file.documentKey || this.file.name;
    }
  }

  onChanged(event): Promise<void> {
    if (event.target.files.length === 0) {
      return;
    }

    this.value = event.target.files[0];
    this.selectedFileName = event.target.files[0].name;

    this.formControl?.setValue(this.value);
    this.changed.emit(this.value);
  }

  removeSelection(key: string): void {
    this.deleteClicked.emit(key);
    this.value = null;
    this.file = null;
  }

  download(key: string): void {
    this.downloadClicked.emit(key);
  }
}
